import { GenericImage } from "./GenericImage";

type Props = {
  height: number;
  width: number;
  className: string
};

export const Logo = (prop: Props) => (
  <>
    <div className={prop.className}>
      <GenericImage height={prop.height} width={prop.width} />
    </div>
  </>
);
